"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kinsideTokens = void 0;
exports.kinsideTokens = {
    "--viridian-0": "#edf5f0",
    "--viridian-5": "#cfe6d5",
    "--viridian-10": "#b4dbc5",
    "--viridian-15": "#a1d1b9",
    "--viridian-20": "#6dc29c",
    "--viridian-30": "#4fb08d",
    "--viridian-40": "#299979",
    "--viridian-50": "#008066",
    "--viridian-60": "#006a55",
    "--viridian-70": "#054",
    "--viridian-80": "#003f33",
    "--gray-0": "#fff",
    "--gray-5": "#fafafa",
    "--gray-10": "#e1e1e1",
    "--gray-15": "#d2d2d2",
    "--gray-20": "#c3c3c3",
    "--gray-30": "#a5a5a5",
    "--gray-40": "#888",
    "--gray-50": "#6f6f6f",
    "--gray-60": "#5a5a5a",
    "--gray-70": "#4c4c4c",
    "--gray-80": "#3b3b3b",
    "--coral-0": "#fff0f0",
    "--coral-5": "#fad8d7",
    "--coral-10": "#fabcbb",
    "--coral-15": "#f7a6a3",
    "--coral-20": "#f98d89",
    "--coral-30": "#e3665f",
    "--coral-40": "#cd4e43",
    "--coral-50": "#b63d31",
    "--coral-60": "#a03124",
    "--coral-70": "#8a291c",
    "--coral-80": "#742115",
    "--gold-0": "#fff7de",
    "--gold-5": "#fff1cc",
    "--gold-10": "#ffe7a6",
    "--gold-15": "#f7da83",
    "--gold-20": "#fed763",
    "--gold-30": "#f7c448",
    "--gold-40": "#e0a73f",
    "--gold-50": "#bf842c",
    "--gold-60": "#a66c1f",
    "--gold-70": "#89510d",
    "--gold-80": "#71400b",
    "--periwinkle-0": "#f2f2ff",
    "--periwinkle-5": "#e0e3ff",
    "--periwinkle-10": "#c8cdff",
    "--periwinkle-15": "#b8bfff",
    "--periwinkle-20": "#a8b0ff",
    "--periwinkle-30": "#8992e3",
    "--periwinkle-40": "#727ac6",
    "--periwinkle-50": "#5f66aa",
    "--periwinkle-60": "#4e548e",
    "--periwinkle-70": "#3e4371",
    "--periwinkle-80": "#2f3255",
    "--teal-0": "#ebf7fc",
    "--teal-5": "#d2e9f4",
    "--teal-10": "#b4d7e9",
    "--teal-15": "#98c6dd",
    "--teal-20": "#7fb6d2",
    "--teal-30": "#569bbb",
    "--teal-40": "#3882a5",
    "--teal-50": "#226c8e",
    "--teal-60": "#165c77",
    "--teal-70": "#0f4c5f",
    "--teal-80": "#0a3b48",
    "--rust-0": "#fcefe8",
    "--rust-5": "#fedfd2",
    "--rust-10": "#fcccb8",
    "--rust-15": "#f9b89d",
    "--rust-20": "#f5a582",
    "--rust-30": "#ea8053",
    "--rust-40": "#da612e",
    "--rust-50": "#c54813",
    "--rust-60": "#ad3401",
    "--rust-70": "#922c01",
    "--rust-80": "#742300",
    "--fuchsia-0": "#fbebfc",
    "--fuchsia-5": "#f3dbf5",
    "--fuchsia-10": "#e7c4eb",
    "--fuchsia-15": "#dcafe0",
    "--fuchsia-20": "#d19bd6",
    "--fuchsia-30": "#bc78c2",
    "--fuchsia-40": "#a75dad",
    "--fuchsia-50": "#924899",
    "--fuchsia-60": "#7e3785",
    "--fuchsia-70": "#6a2b70",
    "--fuchsia-80": "#57205c",
    "--input-focus-color": "#cfe6d5",
    "--ant-color": "#226c8e",
    "--modal-bg-color": "hsla(138, 31%, 86%, 0.8)",
    "--shadow-color": "rgba(81, 81, 81, 0.25)",
    "--shadow-10": "0 1px 2px rgba(81, 81, 81, 0.25)",
    "--shadow-20": "0 2px 2px rgba(81, 81, 81, 0.25)",
    "--transition-fade": "300ms ease-in-out",
    "--breakpoint-phone": "360px",
    "--breakpoint-big-phone": "400px",
    "--breakpoint-tablet": "768px",
    "--breakpoint-big-tablet": "992px",
    "--breakpoint-laptop": "1200px",
    "--breakpoint-big-screen": "1440px",
    "--breakpoint-extra-big-screen": "1600px",
    "--grid-unit": "8px",
    "--radius": "8px",
    "--radius-big": "16px",
    "--sans-serif": "questa-sans, sans-serif",
    "--serif": "mandrel-normal, serif",
    "--font-size-0": "13px",
    "--font-size-10": "18px",
    "--font-size-20": "20px",
    "--font-size-30": "22px",
    "--font-size-40": "26px",
    "--font-size-50": "29px",
    "--font-size-60": "32px",
    "--font-icon-small": "13px",
    "--font-icon-medium": "16px",
    "--font-icon-large": "20px",
};
